import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-property-selector',
  templateUrl: './property-selector.component.html',
  styleUrls: ['./property-selector.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PropertySelectorComponent implements OnInit {


  selectedProperty: { group: string, name: string };
  propertyTree = [
    {
      group: 'astiko', groupLabel: 'Αστικό'
      , nameLabel: ['Βόθροι', 'Φρεάτια', 'Πηγάδια', 'Λοιπές Υδατοσυλλογές'],
      name: ['vothroi', 'freatia', 'pigadia', 'loipes_ydatosylloges']
    },
    {
      group: 'agrotiko', groupLabel: 'Αγροτικό'
      , nameLabel: ['Κανάλια', 'Ρέματα', 'Πηγάδια', 'Λοιπές Υδατοσυλλογές']
      , name: ['kanalia', 'remata', 'pigadia', 'loipes_ydatosylloges']
    },
    {
      group: 'fysiko_systima', groupLabel: 'Φυσικό σύστημα'
      , nameLabel: ['Πλημμυρισμένες εκτάσεις']
      , name: ['plimirismenes_ektaseis']
    }
  ];

  constructor(private app: ContextService) {
    this.selectedProperty = { group: this.propertyTree[0].group, name: this.propertyTree[0].name[0] };
    this.app.propertySelector = this;
  }

  ngOnInit() {
  }

  propertyChanged(group: string, name: string) {
    this.selectedProperty = { group: group, name: name };
    this.app.propertyChanged();
  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/property-selector/property-selector.component.ts